import React from "react";
import { ListGroup as BootstrapListGroup } from "react-bootstrap";
const ListGroup = ({ className = void 0, children = void 0, role = void 0, ...props }) => /* @__PURE__ */ React.createElement(BootstrapListGroup, { bsClass: className, role, ...props }, children);
export default ListGroup;
